import React, { Component } from 'react';
import _ from 'lodash';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';

import styles from './styles';
import { DataTable } from 'components';

import ClassifierGroups from 'views/ClassifierGroups';
import { getAll } from './_actions';

// Inject reducers
import { store } from 'utils/store';
import { classifierGroupsList } from './_reducers';
store.injectReducer('classifierGroupsList', classifierGroupsList);


class ClassifierGroupsList extends Component {

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getAll());
  }

  prepareTableColumns() {
    const { t } = this.props;
    const columns = [
      'ID',
      'LINK',
      t('Kodas'),
      t('Pavadinimas'),
      t('Pastabos'),
      t('Priklauso grupei'),
    ];

    return columns;
  }

  prepareTableData(records) {
    const data = _.map(records, record => {
      let row = [];

      row.push(record._id);
      row.push(`/classifier-groups/${record._id}`);
      row.push(record.code);
      row.push(record.title);
      row.push(record.comment);
      row.push(record.parent);
      
      return row;
    });

    return data;
  }

  render() {
    const { classes, records, isLoading, t } = this.props;
    
    const columns = this.prepareTableColumns();
    const data = this.prepareTableData(records);

    return (
      <ClassifierGroups
        title={t('Klasifikatoriaus grupės')}
        isLoading={isLoading}
        breadcrumbs={[
          { title: t('Administravimas') },
          { title: t('Klasifikatoriaus grupės') }
        ]}
      >
        
        <div className={classes.content}>
          {!isLoading && (
            <DataTable 
              columns={columns}
              data={data}
              tableHeight={window.innerHeight > 900 ? '65vh' : '45vh'}
              createUrl="/classifier-groups/create"
              // onDelete={(idx) => dispatch(deleteOne(companies[idx]._id))}
              // onDeleteBatch={(indexes) => dispatch(deleteBatch(_.map(indexes, (idx) => companies[idx]._id)))}
            />
          )}
        </div>

      </ClassifierGroups>
    );
  }
}

const mapStateToProps = ({ classifierGroupsList, dispatch }) => {
  return { 
    ...classifierGroupsList,
    dispatch,
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
  withTranslation(),
)(ClassifierGroupsList);